import { useMemo } from 'react'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { getRegisteredForEInvoicing } from '../query-api'

export const useIsRegisteredForEInvoicing = () => {
  const { organization, isLoading: isOrganizationLoading } = useUserOrganization()
  const queryParams = useMemo(() => ({ organizationId: organization?.id }), [organization?.id])
  const isQueryEnabled = !isOrganizationLoading && !!organization?.id

  const { data, isLoading } = useQuery(
    [QueryKeys.RegisteredForEInvoicing, queryParams],
    () => getRegisteredForEInvoicing(queryParams),
    {
      enabled: isQueryEnabled,
    },
  )

  const { data: registeredForEInvoicingData } = data || {}
  const isRegistered = (registeredForEInvoicingData || []).length > 0
  const activationDate = registeredForEInvoicingData?.[0]?.registeredAt

  return useMemo(
    () => ({
      isRegistered,
      isLoading,
      activationDate,
    }),
    [isLoading, isRegistered, activationDate],
  )
}
